module.exports = __webpack_public_path__ + "static/media/student_spritemap.66cb9179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/studentPilot/student_spritemap.png
// module id = 890
// module chunks = 0